module.exports = __webpack_public_path__ + "static/img/img_gy_e_c.1a08c2e2.png";